<template>
    <div class="answer" flex="main:center" v-loading="loading">
        <div class="answer-page" flex="cross:top">
            <div class="answer-page--sidebar" v-if="activityType == 1">
                <div class="dot-title no-border" style="margin-top: 20px">答题卡</div>
                <div class="answerScore_box">您本次随堂测验的成绩：<span style="color:#70B603 ;">{{
                    testPaperDetail.answerPaperRecord.answerScore || 0 }}分</span> </div>
                <div class="sidebar-content" style="flex: 1; min-height: 0">
                    <div class="moduleContent" style="flex: 1; min-height: 0">
                        <div class="module" v-for="(
module, moduleIndex
                ) in testPaperDetail.testPaperModuleList" :key="module.id">
                            <div class="module-question">
                                <div class="question-seq" v-for="(question, questionIndex) in module.questionList"
                                    :key="questionIndex">
                                    <div class="question-seq--item" :class="getQuestionStatus(question)"
                                        @click="toQuestion(moduleIndex, questionIndex)">
                                        {{ questionIndex + 1 }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="padding: 20px 0; border-top: 1px solid #f2f2f2">
                        <div flex class="tips">
                            <div class="tips-item" flex="cross:center">
                                <div class="status true"></div>
                                <div class="text">正确</div>
                            </div>

                            <div class="tips-item" flex="cross:center">
                                <div class="status false"></div>
                                <div class="text">错误</div>
                            </div>
                            <div class="tips-item" flex="cross:center">
                                <div class="status answer"></div>
                                <div class="text">未判错</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="answer-page--main" flex="dir:top">
                <div class="testPaper-title">
                    {{ testPaperDetail.paperName }}
                </div>
                <div class="test-paper">
                    <el-scrollbar style="height: 100%" wrap-class="test-paper-wrap" view-class="test-paper-view">
                        <div>
                            <div class="paper-module" v-for="(
module, moduleIndex
                  ) in testPaperDetail.testPaperModuleList" :key="moduleIndex">
                                <div>
                                    <bc-answer-question :dict="{ label: dict.label }"
                                        :class="`answer-module-${moduleIndex}--question-${questionIndex}`"
                                        v-for="(question, questionIndex) in module.questionList" :question="question"
                                        :seq="questionIndex + 1" :key="questionIndex" :typeOk="typeOk"
                                        :styleType="styleType" :answerRecordList="answerQuestionRecordList"
                                        :testPaperDetailName="testPaperDetail.subjectName" :answershow="false"
                                        :aishow="isShowAi ? 'true' : 'false'" @openAi="openAi" :isView="isView"
                                        is-record></bc-answer-question>
                                </div>
                            </div>
                        </div>
                    </el-scrollbar>
                </div>
            </div>
        </div>
        <robot v-if="isShowAi" ref="robotBox" :goodsId="goodsId" :bookName="bookdetail" />
    </div>
</template>

<script>
import robot from "@/components/robot.vue";
import { robotBook } from "@/utils/config.js";
import { goodsInfoDetail } from "@/api/bookstore/bookstore";
import XEUtils from "xe-utils";
import {
    getTestPaperExamInfoByIdApi,
} from "@/api/willingLearn/index.js";
import { isQuestionGroup } from "@/utils/questionType";
export default {
    components: {
        robot,
    },
    name: "answer-record",
    dicts: [
        "paper_type",
        "paper_generate_method",
        "examine_status",
        "difficulty",
        "question_type",
    ],
    data() {
        return {
            styleType: 2,
            typeOk: "other", //false自测和true练习 其他other
            readtype: "", //阅读类型
            bookdetail: "建筑构造",
            goodsId: "",
            robotBook: "",
            showAi: "false",
            loading: false,
            ansRecordId: "",
            testInfo: {},
            testPaperDetail: {
                testPaperModuleList: [],
            },
            answerQuestionRecordList: [],
            testPaperRecord: {},
            timeUse: "",
            questionNum: "",
            paperList: [],
            activityId: '',//随堂检测
            paperId: '',//随堂检测
            activityType: '1', //activityType 0问卷 1 随堂检测
            isView: {
                isViewAnswer: "",
                isViewStatistics: "",
            },
            show: false,

        };
    },
    computed: {
        isShowAi() {
            if (this.robotBook.includes(this.goodsId)) {
                return true
            }
            if (this.$store.getters.threePlatform == 'xueKeKnowledgeBaseSys') {
                return true
            }
            if (this.show) {
                return true
            }
            return false
        }
    },
    created() {
        this.robotBook = robotBook;
        this.paperId = this.$route.query.paperId;
        this.activityId = this.$route.query.activityId;
        this.activityType = this.$route.query.activityType;
        this.getDetail();
    },
    destroyed() { },
    mounted() {
        console.log(
            "🚀 ~ file: answer-record.vue:296 ~ mounted ~ this.showAi:",
            this.showAi
        );
        if (this.showAi == "true") {
            const data = {
                type: "showAi",
                value: true,
                code: "success",
            };
            // 向父vue页面发送信息
            window.parent.postMessage(
                {
                    data,
                },
                "*"
            );
        }
        this.fixShowAi(this.goodsId)
    },
    methods: {
        fixShowAi(id) {
            goodsInfoDetail(id).then((res) => {
                if (res.code == 200 && res.data.xiaoZhi) {
                    this.show = true
                }
                else {
                    this.show = false
                }
            })
        },
        openAi(e) {
            var dataAi = e.replace(/<[^>]+>/g, "");
            this.$refs.robotBox.robotShwo = true;
            this.$refs.robotBox.sending(dataAi);
        },
        getQuestionStatus(question) {
            let record = this.answerQuestionRecordList.find(
                (i) => i.questionId === question.id
            );
            // questionType 8音频/视频 9跟读题 13简答题
            let className = "isFalse";
            if (record) {
                if (
                    question.questionType != 8 &&
                    question.questionType != 9 &&
                    question.questionType != 13
                ) {
                    className = record.answerSituation === "1" ? "isTrue" : "isFalse";
                } else {
                    className = "isAnswer";
                }
            } else {
                if (isQuestionGroup(question.questionType)) {
                    let answerList = question.questionList.map((q) => {
                        let answer = {
                            answerResults: "",
                            answerSituation: "0",
                        };
                        let obj = this.answerQuestionRecordList.find(
                            (i) => q.id === i.questionId
                        );

                        if (obj) {
                            answer.answerResults = obj.answerResults;
                            answer.answerSituation = obj.answerSituation;
                        }
                        return answer;
                    });
                    let allTrue = answerList.every((i) => i.answerSituation === "1");
                    className = allTrue ? "isTrue" : "isFalse";
                }
            }
            return className;
        },
        async getDetail() {
            getTestPaperExamInfoByIdApi({
                activityId: this.activityId,
                paperId: this.paperId
            }).then((res) => {
                this.testPaperDetail = res.data
                this.isView.isViewAnswer = this.testPaperDetail.isViewAnswer
                this.isView.isViewStatistics = this.testPaperDetail.isViewStatistics
                this.testPaperModuleList = res.data.testPaperModuleList
                let paperList = []
                let answerList = []
                this.testPaperModuleList.map((item) => {
                    this.$set(item, 'testPaperNumber', this.testPaperNumber)
                    this.testPaperNumber += item.questionList.length
                    paperList = paperList.concat(item.questionList)

                })
                paperList.map((item) => {
                    if (item.answerQuestionRecordVo) {
                        this.$set(item.answerQuestionRecordVo, 'questionId', item.id)
                    } else {
                        item.answerQuestionRecordVo = {
                            answerResults: "",
                            answerSituation: "",
                            examScore: 0,
                            gradeDescribe: null,
                            questionId: ""
                        }
                        this.$set(item.answerQuestionRecordVo, 'questionId', item.id)
                    }
                    answerList = answerList.concat(item.answerQuestionRecordVo)
                })
                this.paperList = paperList
                this.answerQuestionRecordList = answerList
            });
        },
        toQuestion(moduleIndex, questionIndex) {
            const errorDiv = document.getElementsByClassName(
                `answer-module-${moduleIndex}--question-${questionIndex}`
            );
            errorDiv[0].scrollIntoView({ behavior: "auto" });
        },
        changeNumToHan(num) {
            let arr1 = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
            let arr2 = [
                "",
                "十",
                "百",
                "千",
                "万",
                "十",
                "百",
                "千",
                "亿",
                "十",
                "百",
                "千",
                "万",
                "十",
                "百",
                "千",
                "亿",
            ];
            if (!num || isNaN(num)) return "零";
            let english = num.toString().split("");
            let result = "";
            for (let i = 0; i < english.length; i++) {
                let des_i = english.length - 1 - i; // 倒序排列设值
                result = arr2[i] + result;
                let arr1_index = english[des_i];
                result = arr1[arr1_index] + result;
            }
            result = result.replace(/零(千|百|十)/g, "零").replace(/十零/g, "十"); // 将【零千、零百】换成【零】 【十零】换成【十】
            result = result.replace(/零+/g, "零"); // 合并中间多个零为一个零
            result = result.replace(/零亿/g, "亿").replace(/零万/g, "万"); // 将【零亿】换成【亿】【零万】换成【万】
            result = result.replace(/亿万/g, "亿"); // 将【亿万】换成【亿】
            result = result.replace(/零+$/, ""); // 移除末尾的零
            // 将【一十】换成【十】
            result = result.replace(/^一十/g, "十");
            return result;
        },
    },
};
</script>

<style scoped lang="scss">
::v-deep {
    .text-break-all {
        p {
            img {
                max-width: 100px;
                max-height: 100px;
            }
        }
    }
}

.answer {
    width: 1400px;
    height: 100%;
    // background: #f2f2f2;
    margin: 0 auto;

    .testPaper-title {
        text-align: center;
        padding: 18px;
        font-size: 16px;
        color: #333;
        position: relative;
        line-height: 20px;
        border-bottom: 1px solid #f2f2f2;
    }

    .answer-page {
        display: flex;
        justify-content: center;
        padding-bottom: 20px;

        .answer-page--sidebar {
            width: 304px;
            background: #fffefd;
            border-radius: 6px;
            margin-right: 16px;
            max-height: 100%;
            display: flex;
            height: 850px;
            overflow: hidden;
            overflow-y: auto;
            flex-direction: column;

            .count-down {
                padding: 10px 20px 0;
            }

            .sidebar-content {
                .moduleContent {
                    padding-bottom: 20px;
                    flex: 1;
                    min-height: 0;
                    overflow-y: scroll;

                    &::-webkit-scrollbar,
                    &::-webkit-scrollbar {
                        /*滚动条整体样式*/
                        width: 6px;
                        /*高宽分别对应横竖滚动条的尺寸*/
                        height: 1px;
                    }

                    // 滚动条样式1
                    &::-webkit-scrollbar-thumb {
                        /*滚动条里面小方块*/
                        border-radius: 3px;
                        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
                        background: #dcdee2;
                    }

                    // 滚动条样式2
                    &::-webkit-scrollbar-thumb {
                        /*滚动条里面小方块*/
                        border-radius: 2px;
                        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
                        background: #dcdee2;
                    }

                    .submitBtn {
                        width: 140px;
                        background: #2e9adb;
                        border-radius: 6px;
                        margin: 0 auto;
                        text-align: center;
                        color: #fff;
                        display: block;
                    }

                    .module {
                        padding: 20px 20px 10px;

                        &+.module {
                            border-top: 1px solid #f2f2f2;
                        }

                        .module-name {
                            font-size: 14px;
                            color: #333333;
                            margin-bottom: 15px;
                        }

                        .module-question {
                            margin-left: -5px;
                            margin-right: -5px;

                            &::after,
                            &::before {
                                display: table;
                                content: "";
                            }

                            &::after {
                                clear: both;
                            }

                            .question-seq {
                                padding-left: 6px;
                                padding-right: 5px;
                                float: left;
                                margin-bottom: 10px;

                                .question-seq--item {
                                    width: 30px;
                                    height: 21px;
                                    line-height: 19px;
                                    text-align: center;
                                    background: #ffffff;
                                    border: 1px solid #2e9adb;
                                    //border-radius: 6px;
                                    font-size: 14px;
                                    color: #333333;
                                    user-select: none;
                                    cursor: pointer;
                                    transition: all ease 0.3s;

                                    &.isAnswer {
                                        background: #2e9adb;
                                        color: #fff;
                                    }

                                    &.isTrue {
                                        border-color: #70b603;
                                        background: #70b603;
                                        color: #fff;
                                    }

                                    &.isFalse {
                                        border-color: #d9001b;
                                        color: #fff;
                                        background: #d9001b;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .answer-page--main {
            width: 1080px;
            height: 850px;
            background: #fffefd;
            border-radius: 6px;
            overflow: hidden;
            overflow-y: auto;
            flex-direction: column;

            .paper-detail {
                padding: 20px 40px;
            }

            .record-desc {
                width: 1000px;
                height: 50px;
                line-height: 50px;
                margin: 0 auto;
                background: #f2f2f2;
                border-radius: 6px;
                justify-content: space-around;
            }

            .test-paper {
                flex: 1;
                min-height: 0;

                ::v-deep .test-paper-wrap {
                    overflow-x: hidden;
                }

                ::v-deep .test-paper-view {
                    padding: 0 10px;
                }

                .paper-module {
                    padding: 20px 40px;

                    &+.paper-module {
                        border-top: 1px solid #f2f2f2;
                        //margin-top: 20px;
                    }

                    .paper-module--name {
                        margin-bottom: 24px;
                    }
                }
            }
        }
    }
}

.tags {
    line-height: 1;
    padding: 9px;
    font-size: 14px;
    color: #333333;
    background: #f2f2f2;
    border-radius: 6px;
    margin-right: 16px;
    margin-bottom: 10px;
}

.tips {
    padding: 0px 20px 0px;
    margin-bottom: 10px;
    display: flex;

    .tips-item {
        display: flex;
        margin-left: 20px;

        &:first-child {
            margin-left: 0px;
        }

        .status {
            width: 10px;
            height: 10px;

            &.true {
                background: #70b603;
            }

            &.false {
                background: #d9001b;
            }

            &.answer {
                background: #2e9adb;
            }
        }

        .text {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            margin-left: 6px;
        }
    }
}

::v-deep .question {
    .questionGroupContent {
        display: block;

        .questionType {
            display: inline-block;
        }

        .questionSeq,
        .questionScore {
            display: inline-block;
        }

        .content {
            display: inline;

            .stem-content {
                display: inline;

                .text-break-all {
                    display: inline;

                    p {
                        //display: inline;
                    }
                }
            }
        }
    }

    .group-content {
        display: inline;

        .question {
            padding-left: 20px;
        }
    }

    .stem {
        .stem-box {
            display: block;

            .questionType {
                display: inline-block;
            }

            .questionSeq,
            .questionScore {
                display: inline-block;
            }

            .content {
                display: inline;

                .stem-content {
                    display: inline;

                    .text-break-all {
                        display: inline;

                        p {
                            //display: inline;
                        }
                    }
                }
            }
        }
    }

    .option-item {
        .questionType {
            display: inline-block;
        }

        .questionSeq,
        .questionScore {
            display: inline-block;
        }

        .content {
            display: block;

            .stem-content {
                display: block;

                .text-break-all {
                    display: block;

                    p {
                        display: block;
                    }
                }
            }
        }
    }
}

.dot-title {
    text-align: center;
    margin-top: 10px;
}

.finish_time {
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #666666;
    line-height: 52px;
    text-align: center;
    margin-top: 20px;

    span {
        font-size: 48px;
        color: #d9871f;
    }
}

.result_flex {
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: center;
    width: 901px;
    height: 60px;
    background: #e5f5ff;
    border-radius: 6px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #666666;
    line-height: 60px;
    margin: 20px auto;

    div {
        margin-right: 50px;
    }
}

.result_title {
    border-left: #2e9adb solid 4px;
    padding: 0 10px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 21px;
}

.result_intro {
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: space-between;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 9px;
    margin-top: 20px;
}

.answerScore_box {
    font-size: 15px;
    margin: 10px 20px 5px 20px;
}
</style>